import React, { useEffect, useState } from "react";
import {
    AddJustificationReasonAsync,
    DeleteJustificationReasonAsync,
    GetAssignedPto,
    GetAtRiskDayAsync,
    GetJustificationReasonsAsync,
    JustificationReasonDto,
    UpdateAtRiskDayAsync,
    UpdateJustificationReasonAsync,
    UpdatePTO,
} from "../../../services/taskServices/TaskWorkflowServices";
import { useAuth } from "../../../firebase/AuthProvider";
import Loader from "../loader/Loader";
import editicon from "../../../assets/images/editicon.svg";
import { Button, Table } from "react-bootstrap";
import { EditIcon } from "../../utility/icons/Icons";

const JustificationReason: React.FC = () => {
    const [reasons, setReasons] = useState<JustificationReasonDto[]>([]);
    const { currentUser } = useAuth();
    const [selectedReason, setSelectedReason] = useState<JustificationReasonDto | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [editText, setEditText] = useState("");
    const [loading, setLoading] = useState<boolean>(false);

    const [showAddModal, setShowAddModal] = useState(false);
    const [newReasonText, setNewReasonText] = useState("");

    const [atRiskDay, setAtRiskDay] = useState<number | null>(null);
    const [isEditingAtRisk, setIsEditingAtRisk] = useState(false);
    const [newAtRiskValue, setNewAtRiskValue] = useState<number | null>(null);

    const [assignepto, setassignedpto] = useState<number | null>(null);
    const [isEditingassignedpto, setIsEditingassignedpto] = useState(false);
    const [newassignedptoValue, setNewassignedptoValue] = useState<number | null>(null);

    useEffect(() => {
        const fetchAtRisk = async () => {
            if (!currentUser) return;
            const token = await currentUser.getIdToken();
            const res = await GetAtRiskDayAsync(token);
            if (res.success) {
                setAtRiskDay(res.data);
            }
        };
        fetchAtRisk();
    }, [currentUser]);


    useEffect(() => {
        const fetchAssignedPto = async () => {
            if (!currentUser) return;
            const token = await currentUser.getIdToken();
            const res = await GetAssignedPto(token);
            if (res.success) {
                setassignedpto(res.data);
            }
        };
        fetchAssignedPto();
    }, [currentUser]);
    const handleSaveAtRisk = async () => {
        if (!currentUser || newAtRiskValue === null) return;
        const token = await currentUser.getIdToken();
        const res = await UpdateAtRiskDayAsync(token, newAtRiskValue);
        if (res.success) {
            setassignedpto(newassignedptoValue);
            setIsEditingassignedpto(false);
        }
    };

    const handleupdatePto = async () => {
        if (!currentUser || newassignedptoValue === null) return;
        const token = await currentUser.getIdToken();
        const res = await UpdatePTO(token, newassignedptoValue);
        if (res.success) {
            setAtRiskDay(newAtRiskValue);
            setIsEditingAtRisk(false);
        }
    };
    const handleAdd = async () => {
        if (!currentUser) return;
        try {
            const token = await currentUser.getIdToken();
            const payload = { reasonText: newReasonText };
            const result = await AddJustificationReasonAsync(token, payload);
            setLoading(true);

            if (result.success) {
                setShowAddModal(false);
                setNewReasonText("");
                await fetchData();
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const fetchData = async () => {
        try {
            if (!currentUser) return;
            const authToken = await currentUser.getIdToken();
            const result = await GetJustificationReasonsAsync(authToken);
            setLoading(true);

            if (result.success) {
                setReasons(result.data);
                setLoading(false);

            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleSave = async () => {
        if (!selectedReason || !currentUser) return;

        const payload = {
            id: selectedReason.id,
            reasonText: editText,
            isActive: selectedReason.isActive,
        };

        try {
            const authToken = await currentUser.getIdToken();
            setLoading(true);
            const result = await UpdateJustificationReasonAsync(authToken, payload);

            if (result.success) {
                setShowModal(false);

                setSelectedReason(null);
                await fetchData(); // refresh table
                setLoading(false);
                setEditText("")
            }
        } catch (err) {
            setLoading(true);

            console.error(err);
        }
    };

    const handleToggle = async (id: number) => {
        try {
            if (!currentUser) return;
            const token = await currentUser.getIdToken();

            const result = await DeleteJustificationReasonAsync(token, id);
            setLoading(true);

            if (result.success) {
                await fetchData();
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            {loading && <Loader />}
            {/* At-Risk Submission Days Section */}
            <div className="mby_24">
                <div className="row">
                    {/* At-Risk Submission Days */}
                    <div className="col-md-12 col-md-6 col-lg-6 col-xl-6 mb-4 mb-xl-0">
                        <div className="common_card h-100">
                            <h5 className="fw-semibold mb-3">At-Risk Submission Days</h5>
                            <div className="flex items-center gap-2">
                                {isEditingAtRisk ? (
                                    <>
                                    <div className="custom_input_flled mb-0">
                                        <input
                                            type="number"
                                            value={newAtRiskValue ?? atRiskDay ?? ""}
                                            onChange={(e) => setNewAtRiskValue(parseInt(e.target.value))}
                                            className="filled_white form-control sm_input"
                                            placeholder="Days"
                                        />
                                    </div>
                                        <Button variant="secondary" onClick={() => setIsEditingAtRisk(false)}className="btn_sm">Cancel</Button>
                                        <Button variant="primary" onClick={handleSaveAtRisk} className="btn_sm">Save</Button>
                                    </>
                                ) : (
                                    <>
                                        <span className="text-gray-800 font-medium text-lg">
                                            {atRiskDay ?? "--"}
                                        </span>
                                        <button
                                            onClick={() => {
                                                setNewAtRiskValue(atRiskDay);
                                                setIsEditingAtRisk(true);
                                            }}
                                            className="p-2 rounded-full hover:bg-gray-100 transition"
                                        >
                                            <EditIcon/>
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* PTO Days */}
                    <div className="col-md-12 col-md-6 col-lg-6 col-xl-6 mb-4 mb-xl-0">
                        <div className="common_card h-100">
                            <h5 className="fw-semibold mb-3">PTO Days</h5>
                            <div className="flex items-center gap-2">
                                {isEditingassignedpto ? (
                                    <>
                                        <div className="custom_input_flled mb-0">
                                            <input
                                                type="number"
                                                value={newassignedptoValue ?? assignepto ?? ""}
                                                onChange={(e) => setNewassignedptoValue(parseInt(e.target.value))}
                                                className="filled_white form-control sm_input"
                                                placeholder="Days"
                                            />
                                        </div>
                                        <Button variant="secondary"
                                            onClick={() => setIsEditingassignedpto(false)}
                                            className="btn_sm"
                                        >
                                            Cancel
                                        </Button>
                                        <Button variant="primary"
                                            onClick={handleupdatePto}
                                            className="btn_sm"
                                        >
                                            Save
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <span className="text-gray-800 font-medium text-lg">
                                            {assignepto ?? "--"}
                                        </span>
                                        <button
                                            onClick={() => {
                                                setNewassignedptoValue(assignepto);
                                                setIsEditingassignedpto(true);
                                            }}
                                            className="p-2 rounded-full hover:bg-gray-100 transition"
                                        >
                                            <EditIcon/>
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="common_card">
                <div className="top top_bar_flx">
                    <div className="top_bar_tittle">
                        <h2>Justification Reason</h2>
                    </div>
                    <div className="top_right_flx">
                        <Button variant="primary" className="btn_sm" onClick={() => setShowAddModal(true)}>Add Reason</Button>
                    </div>
                </div>

                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>SQ</th>
                            <th>Reason</th>
                            <th>Toggle</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reasons.map((row, index) => (
                            <tr key={row.id}>
                                <td>{index + 1}</td>
                                <td>{row.reasonText}</td>
                                <td>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            className="sr-only peer"
                                            checked={row.isActive}
                                            onChange={() => handleToggle(row.id)}
                                        />
                                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-green-500 transition-all">
                                            <div className="absolute top-0.5 left-0.5 bg-white w-5 h-5 rounded-full transition-transform peer-checked:translate-x-5"></div>
                                        </div>
                                    </label>
                                </td>
                                <td>
                                    <button
                                        className="text-blue-600 hover:underline"
                                        onClick={() => {
                                            setSelectedReason(row);
                                            setEditText(row.reasonText);
                                            setShowModal(true);
                                        }}
                                    >
                                        Edit
                                    </button>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Modal */}
                {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-white/30 z-50">

                        <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                            <h2 className="text-lg font-semibold mb-4">Edit Justification Reason</h2>
                            <textarea
                                className="w-full border border-gray-300 rounded-md p-2 mb-4"
                                rows={4}
                                value={editText}
                                onChange={(e) => setEditText(e.target.value)}
                            />
                            <div className="flex justify-end gap-3">
                                <button
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showAddModal && (
                    <div className="fixed inset-0 flex items-center justify-center backdrop-blur-sm bg-white/30 z-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                            <h2 className="text-lg font-semibold mb-4">Add Justification Reason</h2>
                            <textarea
                                className="w-full border border-gray-300 rounded-md p-2 mb-4"
                                rows={3}
                                value={newReasonText}
                                onChange={(e) => setNewReasonText(e.target.value)}
                            />
                            <div className="flex justify-end gap-3">
                                <button
                                    className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400"
                                    onClick={() => {
                                        setShowAddModal(false);
                                        setNewReasonText("");
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                                    onClick={handleAdd}
                                    disabled={!newReasonText.trim()}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </>
    );
};

export default JustificationReason;
